<script>
    import BrandImage from "@xd/components/BrandImage";
    import BrandLink from "@xd/components/BrandLink";

    export default {
        name: "BrandProductSoftDaypack",
        components: { BrandLink, BrandImage },
        props: {
            product: Object,
            visibleElements: Array,
        },
        methods: {
            checkElement(index) {
                return !this.visibleElements.includes(index.toString());
            },
        },
    };
</script>

<template>
    <div class="brand-product" :id="product.slug">
        <div class="l-container">
            <div class="brand-product__body">
                <div class="brand-product__col">
                    <header class="brand-product__header">
                        <div
                            class="brand-product__title"
                            :class="{ 'is-animated': checkElement('title') }"
                            data-name="title"
                        >
                            {{ product.title }}
                        </div>
                        <div
                            class="brand-product__date"
                            :class="{ 'is-animated': checkElement('date') }"
                            data-name="date"
                        >
                            {{ product.date }}
                        </div>
                    </header>

                    <div class="brand-product__image image-1">
                        <brand-image
                            :image="product.image"
                            index="1"
                            :is-animated="checkElement('image-1')"
                            data-name="image-1"
                        ></brand-image>
                    </div>
                </div>

                <div class="brand-product__col">
                    <div
                        class="brand-product__text text-1"
                        :class="{ 'is-animated': checkElement('text-1') }"
                        data-name="text-1"
                        v-html="product.text[0]"
                    ></div>

                    <div class="brand-product__image image-2">
                        <brand-image
                            :image="product.image"
                            index="2"
                            :is-animated="checkElement('image-2')"
                            data-name="image-2"
                        ></brand-image>
                    </div>

                    <brand-link
                        class="brand-product__link"
                        :slug="product.slug"
                        :is-animated="checkElement('link')"
                        data-name="link"
                    ></brand-link>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .brand-product {
        padding: 100px 16px 10px;
        @include bp($bp-desktop-sm) {
            padding: 140px 0 150px;
        }
    }

    .brand-product__header {
        margin-bottom: 40px;
        @include bp($bp-desktop-lg) {
            margin-bottom: 80px;
        }
    }

    .brand-product__title {
        @include bp($bp-desktop-sm) {
            margin-right: 40px;
            white-space: nowrap;
        }
    }

    .brand-product__date {
        @include bp($bp-desktop-sm) {
            white-space: nowrap;
        }
    }

    .brand-product__body {
        @include bp($bp-desktop-lg) {
            display: flex;
            margin: 0 -90px;
        }
    }

    .brand-product__col {
        @include bp($bp-desktop-lg) {
            flex-grow: 1;
            margin: 0 90px;
            &:first-child {
                flex-basis: 604px;
                max-width: 604px;
            }
            &:last-child {
                display: flex;
                flex-direction: column;
            }
        }
    }

    .brand-product__image {
        &.image-1 {
            margin-bottom: 40px;
            &::before {
                padding-bottom: 144%;
            }
            @include bp($bp-desktop-lg) {
                max-width: 604px;
                margin-bottom: 0;
            }
        }

        &.image-2 {
            width: calc(100% + 32px);
            margin-right: -32px;
            margin-bottom: 40px;
            &::before {
                padding-bottom: 62.8%;
            }
            @include bp($bp-desktop-lg) {
                order: -1;
                max-width: none;
                width: 565px;
                margin-right: -90px;
                margin-bottom: 55px;
            }
        }
    }

    .brand-product__text {
        @include bp($bp-desktop-lg) {
            max-width: 430px;
        }
        &.text-1 {
            margin-bottom: 16px;
            @include bp($bp-desktop-lg) {
                margin-bottom: 24px;
            }
        }
    }

    .brand-product__link {
        @include bp($bp-desktop-lg) {
            margin-top: auto;
        }
    }
</style>
